<template>
  <el-card shadow="never">
    <div slot="header">
      <span>分红检查</span>
      <el-button 
        :loading="loading"
        icon="el-icon-refresh" 
        circle 
        size="small" 
        style="margin-left: 10px;" 
        @click="handleCheck"></el-button>
    </div>
    <div>
      <el-form :inline="true">
        <el-form-item label="分红时间：">
          <el-date-picker type="date" placeholder="选择日期" v-model="shareTime"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="checkShareList"
      >
        <el-table-column
          prop="id"
          label="ID">
        </el-table-column>
        <el-table-column
          prop="checkType"
          label="Check Type">
        </el-table-column>
        <el-table-column
          prop="businessId"
          label="Business ID">
        </el-table-column>
        <el-table-column
          prop="checkResultCode"
          label="Check Result Code">
        </el-table-column>
        <el-table-column
          prop="checkTime"
          label="Check Time">
          <template slot-scope="scope">
            {{ scope.row.checkTime | moment('YYYY-MM-DD')}}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="Create Time">
          <template slot-scope="scope">
            {{ scope.row.createTime | moment('YYYY-MM-DD')}}
          </template>
        </el-table-column>
        <el-table-column
          prop="resultDes"
          label="Result Des">
        </el-table-column>
      </el-table>
    </div>
  </el-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'ShareCheck',
  data() {
    return {
      loading: false,
      shareTime: null
    };
  },
  computed: {
    ...mapState('miningShare', ['checkShareList'])
  },
  methods: {
    ...mapActions('miningShare', ['checkShare', 'getCheckShareList']),
    handleSearch() {
      if (!this.shareTime) {
        this.$message.error('请选择分红时间！');
      } else {
        this.getCheckShareList(this.shareTime);
      }
    },
    handleCheck() {
      this.loading = true;

      this.checkShare()
        .then(({ data }) => {
          this.$alert(data, '结果', { type: 'info' });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="less" scoped>
.el-card {
  margin-top: 20px;
}
</style>
